//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import LenderSubmissionChangesTable from "./lender-submission-changes-table.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConfirmSubmissionModal",
  components: {
    GenericModal,
    SimpleButton,
    LenderSubmissionChangesTable
  },
  props: {
    applicationId: {
      type: [Number, String],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    completeStatus: {
      type: String,
      default: ""
    },
    lenderSubmissions: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    },
    applicationCompleted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCompleteApplicationClick() {
      this.$emit("submit", this.completeStatus);
    }
  }
});